import { AttendanceLogModel } from "@gtpl/shared-models/hrms";
import { Injectable } from "@nestjs/common";
import { AttendanceLogEntity } from "../entities/attendance-log.entity";
import { AttendanceLogRequest } from "./attendance-log.request";

@Injectable()
export class AttendanceLogAdapter {

    public convertDtoToEntity(attdLogReq: AttendanceLogRequest): AttendanceLogEntity {
        const attdLogEnt = new AttendanceLogEntity();
        attdLogEnt.logDate = attdLogReq.logDate;
        attdLogEnt.employeeCode = attdLogReq.employeeCode;
        attdLogEnt.deviceCode = attdLogReq.deviceCode;
        attdLogEnt.downloadDate = attdLogReq.downloadDate;
        attdLogEnt.verifyMode = attdLogReq.verifyMode;
        attdLogEnt.direction = attdLogReq.direction;
        attdLogEnt.employeeName = attdLogReq.employeeName;

        return attdLogEnt;
    }

    public convertEntityToDto(attdLogEnt: AttendanceLogEntity): AttendanceLogModel {
        return new AttendanceLogModel(attdLogEnt.logDate, attdLogEnt.employeeCode, attdLogEnt.deviceCode, attdLogEnt.downloadDate, attdLogEnt.verifyMode, attdLogEnt.direction, attdLogEnt.employeeName);
    }
}